import React from "react";
import { Switch, Route, Link, withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

import variables from "../variables.scss";
import "./style.scss";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { emphasize, withStyles } from "@material-ui/core/styles";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Chip from "@material-ui/core/Chip";

import { GoogleLogin, GoogleLogout } from "react-google-login";

// import Users from "./Users";
// import Files from "./Files";
import Loader from "../loaders";
import Home from "./Home";

import Product from "./Product";
import ProductItem from "./Product/Item";
import ProductItemStock from "./Product/Item/Stock";
import Stock from "./Stock";
import StockItem from "./Stock/Item";
import StockItemSupplier from "./Stock/Item/Supplier";
import Users from "./Users";
import Files from "./Files";
import SignIn from "./SignIn";

import Supplier from "./Supplier";
import Customer from "./Customer";
import Purchases from "./Purchases";
import PurchasesCheckout from "./Purchases/Checkout";
import PurchasesCreate from "./Purchases/Create";
import PurchasesMultiCreate from "./Purchases/MultiCreate";

import Orders from "./Orders";
import OrdersCreate from "./Orders/Create";

import DocumentCreator from "./Document/Creator";
import DocumentViewer from "./Document/Viewer";

import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ReceiptIcon from "@material-ui/icons/Receipt";
import ExtensionIcon from "@material-ui/icons/Extension";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import WorkIcon from "@material-ui/icons/Work";
import PeopleIcon from "@material-ui/icons/People";
import CloudIcon from "@material-ui/icons/Cloud";

class Navigation extends React.Component {
  item(route) {
    const { currentRoute } = this.props;

    const isCurrent = currentRoute?.slug === route.slug;

    return (
      <Link
        to={route.slug}
        key={route.slug}
        className={isCurrent ? "is-active" : ""}
        color="primary"
      >
        <ListItem dense button selected={isCurrent}>
          <ListItemText primary={route.name} />
        </ListItem>
      </Link>
    );
  }
  render() {
    const { routes } = this.props;

    const items = routes.reduce(
      (agg, item) => (item.name ? [...agg, item] : agg),
      []
    );

    return (
      <div className="navigation">{items.map((route) => this.item(route))}</div>
    );
  }
}

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: variables.colourPrimaryMain,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: "#0066ff",
      main: variables.colourSecondaryMain,
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#ffcc00",
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});

class Application extends React.Component {
  state = {
    isGoogleLoggedIn: false,
    isLoggedIn: localStorage.getItem("token") ?? false,
  };
  routes = [
    {
      slug: "/",
      component: Home,
    },
    {
      name: "Stock",
      slug: "/stock",
      component: Stock,
      icon: ExtensionIcon,
    },
    {
      slug: "/stock/:id",
      component: StockItem,
    },
    {
      slug: "/stock/:id/supplier/:supplier_id",
      component: StockItemSupplier,
    },
    {
      name: "Suppliers",
      slug: "/suppliers",
      component: Supplier,
      icon: GroupWorkIcon,
    },
    {
      name: "Products",
      slug: "/products",
      component: Product,
      icon: WorkIcon,
    },
    {
      slug: "/products/:id",
      component: ProductItem,
    },
    {
      slug: "/products/:id/stock/:group_id",
      component: ProductItemStock,
    },
    {
      name: "Customers",
      slug: "/customers",
      component: Customer,
      icon: GroupWorkIcon,
    },
    {
      name: "Orders",
      slug: "/orders",
      component: Orders,
      icon: MonetizationOnIcon,
    },
    {
      slug: "/orders/create",
      component: OrdersCreate,
    },
    {
      slug: "/orders/:id",
      component: OrdersCreate,
    },
    {
      name: "Purchases",
      slug: "/purchases",
      component: Purchases,
      icon: ReceiptIcon,
    },
    {
      slug: "/purchases/checkout",
      component: PurchasesCheckout,
    },
    {
      slug: "/purchases/create",
      component: PurchasesMultiCreate,
    },
    {
      slug: "/purchases/:id",
      component: PurchasesCreate,
    },
    {
      slug: "/document/create/:type/:id",
      component: DocumentCreator,
      frameless: true,
    },
    {
      slug: "/document/view/:type/:id",
      component: DocumentViewer,
    },
    {
      name: "Users",
      slug: "/users",
      component: Users,
      icon: PeopleIcon,
    },
  ];

  onBreadcrumbClick(item) {
    this.props.history.push(item.slug);
  }

  onGoogleResponse(data) {
    const { Da, Pt, accessToken, googleId, tokenId } = data;

    this.__googleData = {
      Da,
      Pt,
      accessToken,
      googleId,
      tokenId,
    };

    localStorage.setItem("google", JSON.stringify(this.__googleData));

    this.setState({
      isGoogleLoggedIn: true,
    });
  }
  onGoogleLogoutResponse(data) {
    this.setState({
      isGoogleLoggedIn: false,
    });

    localStorage.removeItem("google");
  }

  __googleData = null;

  get googleData() {
    if (!this.__googleData) {
      this.__googleData = JSON.parse(localStorage.getItem("google"));
    }

    return this.__googleData;
  }

  get isGoogleLoggedIn() {
    return this.state.isGoogleLoggedIn;
  }

  render() {
    const { isLoggedIn } = this.state;
    const isLoading = this.props.isLoading;

    const isCurrent = (slug) => {
      const { pathname } = window.location;
      const current = pathname.split("/");
      const existing = slug.split("/");

      return (
        existing
          .map((item, key) =>
            item.includes(":") ? current?.[key] ?? item : item
          )
          .join("/") === pathname
      );
    };

    const currentRoutes = this.routes.reduce(
      (agg, route) => (isCurrent(route.slug) ? [...agg, route] : agg),
      []
    );

    const currentRoute = currentRoutes?.[0] ?? null;

    const isFrameless = currentRoute?.frameless;

    return (
      <React.Fragment>
        <ThemeProvider theme={theme}>
          {isFrameless ? (
            <Switch>
              {this.routes.map((route) => (
                <Route
                  path={route.slug}
                  key={route.slug}
                  exact
                  render={({ history, match }) => (
                    <route.component history={history} match={match} />
                  )}
                />
              ))}
            </Switch>
          ) : (
            <div className="app">
              {isLoggedIn ? (
                <React.Fragment>
                  {isLoading ? (
                    <div className="loader">
                      <p>Loading</p>
                    </div>
                  ) : (
                    <div className="body">
                      <div className="column navigation">
                        <Navigation
                          routes={this.routes}
                          currentRoute={currentRoute}
                        />
                        <div className="logo">SCS20</div>
                      </div>
                      <div className="column breadcrumbs">
                        <Breadcrumbs aria-label="breadcrumb">
                          {this.props.breadcrumbs.map((item) => (
                            <div
                              className="crumb"
                              onClick={() => this.onBreadcrumbClick(item)}
                            >
                              {item.name}
                            </div>
                          ))}
                        </Breadcrumbs>
                      </div>
                      <div className="column content">
                        <div className="content">
                          <Switch>
                            {this.routes.map((route) => (
                              <Route
                                path={route.slug}
                                key={route.slug}
                                exact
                                render={({ history, match }) => (
                                  <route.component
                                    history={history}
                                    match={match}
                                  />
                                )}
                              />
                            ))}
                          </Switch>
                        </div>
                      </div>
                      <div className="column footer">
                        {this.isGoogleLoggedIn ? (
                          <GoogleLogout
                            clientId="803029188243-diqb2ggreq613gvghc3bd4jug23cnjgv.apps.googleusercontent.com"
                            onLogoutSuccess={(data) =>
                              this.onGoogleLogoutResponse(data)
                            }
                          />
                        ) : (
                          <GoogleLogin
                            clientId="803029188243-diqb2ggreq613gvghc3bd4jug23cnjgv.apps.googleusercontent.com"
                            onSuccess={(data) => this.onGoogleResponse(data)}
                            onFailure={() => {}}
                            cookiePolicy={"single_host_origin"}
                            isSignedIn={true}
                            scope={
                              "profile email https://www.googleapis.com/auth/gmail.compose"
                            }
                          />
                        )}
                      </div>
                    </div>
                  )}
                  <Loader />
                </React.Fragment>
              ) : (
                <div className="body">
                  <div className="column navigation">
                    <div className="title">Please sign in to continue</div>
                    <div className="logo">SCS20</div>
                  </div>
                  <div className="column content">
                    <SignIn
                      onLoggedIn={() => this.setState({ isLoggedIn: true })}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </ThemeProvider>
      </React.Fragment>
    );
  }
}

export default connect((state) => {
  return {
    breadcrumbs: state.view.crumbs,
    isLoading:
      state.stock.isLoading ||
      state.stock.ledger.isLoading ||
      state.stock.supplier.isLoading ||
      state.stock.supplier.price.isLoading ||
      state.supplier.isLoading ||
      state.product.isLoading ||
      state.product.group.isLoading ||
      state.product.stock.isLoading ||
      state.customer.isLoading ||
      state.order.isLoading ||
      state.order.item.isLoading ||
      state.purchase.isLoading ||
      state.purchase.item.isLoading,
  };
})(withRouter((props) => <Application {...props} />));
